const IconClear = () => {
  return (
    <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_1231)">
        <path
          d="M29.4188 2.68594C30.075 2.17501 30.1922 1.23282 29.6813 0.581257C29.1704 -0.0703052 28.2282 -0.19218 27.5766 0.318757L20.8266 5.56876L17.4516 8.19376L17.0438 8.51251L15.6001 6.66563C15.4266 6.44063 15.1407 6.33751 14.8594 6.39376C14.5782 6.45001 14.3579 6.66094 14.2829 6.93282L13.6969 9.10313L17.3954 13.8281L19.6454 13.7859C19.9313 13.7813 20.1844 13.6125 20.3063 13.3594C20.4282 13.1063 20.3954 12.8016 20.2219 12.5766L18.8907 10.8703L19.2938 10.5563L22.6688 7.93126L29.4188 2.68126V2.68594ZM0.782864 23.7984C2.53599 23.9297 10.0079 24.3609 12.6094 22.3266C15.3141 20.2125 16.2094 14.7563 16.2094 14.7563L12.5204 10.0266C12.5204 10.0266 7.00786 9.57657 4.30318 11.6906C3.23443 12.5203 2.36724 14.2547 1.70161 16.125C1.58911 16.4391 1.92193 16.725 2.21724 16.5656L4.04068 15.6094C4.23286 15.5063 4.47193 15.5578 4.60318 15.7313C4.73443 15.9047 4.72974 16.1438 4.58443 16.3078L1.1438 20.175C0.618801 20.7609 0.257864 21.4734 0.112551 22.2422C0.0703639 22.4672 0.0375514 22.6594 0.00942643 22.8094C-0.0327611 23.0438 0.0328639 23.2828 0.178176 23.4703C0.323489 23.6578 0.539114 23.7797 0.778176 23.7984H0.782864Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_1231">
          <rect width="30" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconClear;
